<template>
  <div
    :class="['chat__avatar', { '--agent': !isHunter, '--hunter': isHunter, '--scroll': scroll }]"
    :style="`--offsetTop: ${offsetTop / 16}rem`"
  >
    <Image :source="$beet.options.hunt.contextBotIcon" v-if="!isHunter" />
    <AvatarHead v-if="isHunter" />
  </div>
</template>

<script>
import { AvatarHead } from '@/components/avatar'
import { Image } from '@/components/global'

export default {
  name: 'ChatAvatar',
  components: { AvatarHead, Image },
  props: {
    isHunter: {
      type: Boolean,
      default: false,
    },
    offsetTop: {
      type: Number,
      default: null,
    },
    scroll: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
